// extracted by mini-css-extract-plugin
export default {"container":"Message_container__EeYAe","btn":"Message_btn__mzE10","badge":"Message_badge__IiGve","list":"Message_list__OGXje"};